<template>
  <div class="impressao-formulario" id="impressao-page">
    <div class="impressao-header">
      <div><img src="../../assets/images/logo-econet-2.png" alt="logo-econet-2" /></div>
      <div>
        <p>Relatório gerado às {{ imprimirHora() }} em {{ imprimirData() }}</p>
        <p>por: {{ nomeUsuario }}</p>
      </div>
    </div>
    <div class="impressao-topo">
      <div><img src="../../assets/images/logo-rte_old2.png" alt="logo-econet-2" /></div>
      <div>
        <h1>Apresentação de Resultados</h1>
        <h3>Relatório Detalhado</h3>
      </div>
    </div>
    <h1 class="impressao-titulo">{{ nomeCenario }}</h1>
    <DadoCenarioImpressao :dadosCenario="dadosCenario" />
  </div>
</template>

<script>
import DadoCenarioImpressao from "../impressao/DadoCenarioImpressao.vue";

export default {
  name: "ImpressaoCenario",
  props: {
    nomeCenario: String,
    cnaeRemetenteLabel: String,
    cnaeDestinatarioLabel: String,
    ncm: Object,
    dadosForm: Object,
    filtros: Object
  },
  components: { DadoCenarioImpressao },
  data() {
    return {
      nomeUsuario: window.localStorage.getItem("nome_usuario")
    };
  },
  computed: {
    dadosCenario() {
      let dados = {
        tipoDeOperacao: this.filtro("local", this.dadosForm.tipoOperacao),
        paisOrigem: this.filtro("pais_origem", this.dadosForm.paisOrigem),
        paisDestino: this.filtro("pais_destino", this.dadosForm.paisDestino),
        ufOrigem: this.filtro("estado_origem", this.dadosForm.ufOrigem),
        ufDestino: this.filtro("estado_destino", this.dadosForm.ufDestino),
        origem: this.filtro("origem_mercadoria", this.dadosForm.origem),
        destinacao: this.filtro("destinacao", this.dadosForm.destinacao),
        ncm: this.dadosForm.ncm,
        ncmDescricao: this.ncm ? this.ncm.descricao : '',
        cnaeRem: this.dadosForm.cnaeRemetente ? this.cnaeRemetenteLabel : '',
        cnaeDes: this.dadosForm.cnaeDestinatario ? this.cnaeDestinatarioLabel : '',
        atividadeRem: this.filtro("atividade", this.dadosForm.atividadeRemetente),
        atividadeDes: this.filtro("atividade", this.dadosForm.atividadeDestino),
        tipoAtividadeRem: this.filtro("tipo_atividade", this.dadosForm.tipoAtividadeRem),
        tipoAtividadeDes: this.filtro("tipo_atividade", this.dadosForm.tipoAtividade),
        regimeRem: this.filtro("regime_tributacao", this.dadosForm.regimeRemetente),
        regimeDes: this.filtro("regime_tributacao", this.dadosForm.regimeDestinatario),
        receitaBruta: this.dadosForm.sn_rbt12,
        receitaAcumulada: this.dadosForm.sn_rba,
        receitaMes: this.dadosForm.sn_rm,
        zfm: this.dadosForm.zfm,
        cnpjRem: this.dadosForm.cnpjRemetente,
        cnpjDes: this.dadosForm.cnpjDestinatario,
        mostraPaisOrigem: this.dadosForm.paisOrigem != "" ? true : false,
        mostraPaisDestino: this.dadosForm.paisDestino != "" ? true : false,
        mostraUfOrigem: this.dadosForm.ufOrigem != "" ? true : false,
        mostraUfDestino: this.dadosForm.ufDestino != "" ? true : false,
        mostraOrigem: this.dadosForm.origem != "" ? true : false,
        mostraDestinacao: this.dadosForm.destinacao != "" ? true : false,
        mostraAtividadeRem: this.dadosForm.atividadeRemetente != "" ? true : false,
        mostraAtividadeDes: this.dadosForm.atividadeDestino != "" ? true : false,
        mostraTipoAtividadeRem: this.dadosForm.tipoAtividadeRem != "" ? true : false,
        mostraTipoAtividadeDes: this.dadosForm.tipoAtividade != "" ? true : false,
        mostraRegimeRem: this.dadosForm.regimeRemetente != "" ? true : false,
        mostraRegimeDes: this.dadosForm.regimeDestinatario != "" ? true : false,
        mostraRem: this.dadosForm.tipoOperacao != "41" ? true : false
      };
      return dados;
    }
  },
  methods: {
    imprimirHora() {
      let hora = new Date()
        .getHours()
        .toString()
        .padStart(2, "0");
      let minuto = new Date()
        .getMinutes()
        .toString()
        .padStart(2, "0");

      return hora + ":" + minuto;
    },
    imprimirData() {
      let dia = new Date()
        .getDate()
        .toString()
        .padStart(2, "0");
      let mes = (new Date().getMonth() + 1).toString().padStart(2, "0");
      let ano = new Date().getFullYear();

      return dia + "/" + mes + "/" + ano;
    },
    filtro(campo, valor) {
      let dado = this.filtros[campo].valores.find(f => f.value == valor);
      return dado ? dado.label : null;
    }
  }
};
</script>

<style lang="scss" scoped>
.impressao-header {
  display: flex;
  justify-content: space-between;
  padding-bottom: 15px;
  border-bottom: 1px solid var(--preto);
  margin-left: 25px;
  margin-right: 25px;
}
.impressao-topo {
  display: flex;
  margin: 20px;
  img {
    width: 250px;
    height: auto;
  }
  h1,
  h3 {
    color: var(--preto) !important;
    margin: 20px 60px !important;
  }
}
.impressao-titulo {
  color: var(--preto);
  margin: 20px 35px 20px 25px;
  word-wrap: break-word;
}
</style>
